import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import InputField, { FormMessage } from '../../../components/Input-field/input-field.component';
import Button, { BUTTON_TYPE_CLASSES } from '../../../components/button/button.component';
import Alert, { ALERT_TYPE } from '../../../components/alert/alert.component';
import { useAuth } from '../../../Contexts/auth.context';
import { CMDiv } from '../login/login.styles';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { user_emailExisting, user_resendcode, user_signup, user_signupApple, user_signupGoogle } from '../../../Services/prod/auth.service';
import { useContext, useEffect, useState } from 'react';
import Heading from '../../../components/heading/heading.component';
import { SignupContainer, WelcomeModal, BackButton, HeadContainer, BTNsmall, CMCloseButton } from './signup.styles';
import { ReactComponent as CheckIcon } from '../../../icons/white-check.svg';
import Dropdown from '../../../components/dropdown/dropdown.component';
import Image from '../../../components/image/image.component';
import { useCatalogue } from '../../../Contexts/catalogue.context';
import Datepicker, { DatepickerErrorMessage, FormDatePicker2 } from '../../../components/datepicker/datepicker2.component';
import Datepicker2 from '../../../components/datepicker/datepicker2.component';
import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import { Col, Row } from 'react-bootstrap';
//import { getAccessToken } from '../../../Utils/amplify.utils';
//import { signOut } from 'aws-amplify/auth';
import TermsAndConditions from '../../Public/terms-and-conditions/TermsAndConditions';
import PrivacyContent from '../../Public/privacy-notice/PrivacyContent';
import { decodeJWT } from '../../../Utils/common.utils';
import { ReactComponent as CloseIcon } from "../../../Assets/close.svg";
import TermsModal from '../../../components/terms-modal/terms-modal.component';

const accountTypeCompanyOptions = [
  {
    value: 'Individual',
    text: 'Individual',
  },
  {
    value: 'Company',
    text: 'Company',
  }
]

const CompanyOptions = [
  {
    value: 'LLC',
    text: 'LLC',
  },
  {
    value: 'INC',
    text: 'INC',
  }
]

//Password Validation
const passwordValidationRules = [
  {
    rule: (value) => value.length >= 8,
    message: "8 Characters",
  },
  {
    rule: (value) => value.length <= 30,
    message: "Max 30 characters",
  },
  {
    rule: (value) => /^(?=.*[A-Za-z])/.test(value),
    message: "1 Letter",
  },
  {
    rule: (value) => /^(?=.*\d)/.test(value),
    message: "1 Number",
  },
  {
    rule: (value) => /^(?=.*[a-z])/.test(value),
    message: "1 Lowercase",
  },
  {
    rule: (value) => /^(?=.*[A-Z])/.test(value),
    message: "1 Uppercase",
  },
  {
    rule: (value) => /^(?=.*[@$!%*#?&/^*_-])/.test(value),
    message: "1 Special character",
  },
];


const loginSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^[\p{L}\p{Script=Han}\s-]+$/u, 'Enter a valid First Name')
    .trim()
    .required('First Name is required')
    .max(20, 'First Name cannot be more than 20 characters'),
   lastName: Yup.string().when("useOauth", (useOauth, field) =>
  !useOauth
    ? field
        .matches(/^[\p{L}\p{Script=Han}\s-]+$/u, "Enter a valid Last Name")
        .trim()
        .required("Last Name is required")
        .max(20, "Last Name cannot be more than 20 characters")
    : field),
  email: Yup.string()
    .email('Invalid email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  confirmEmail: Yup.string()
    .email('Invalid email format')
    .required('Please confirm your email address')
    .test('emails-match', "Email addresses don't match", function (value) {
      const { email } = this.parent;
      return email?.toLowerCase() === value?.toLowerCase();
    }),
  accountType: Yup.string()
    .required('Please, select the user type.'),
  country: Yup.string().required('Please, select a country.'),
  phoneNumber: Yup.string()
  .when('countryCode', {
    is: (countryCode) => !!countryCode, 
    then: Yup.string()
      .matches(/^\d+$/, 'Enter a valid phone number')
      .test('is-valid-phone-number', 'Enter a valid phone number', function (value) {
        const { countryCode } = this.parent;

        if (!countryCode || !value) return true; 

        const fullPhoneNumber = `${countryCode}${value}`;
        try {
          const phoneNumber = parsePhoneNumberFromString(fullPhoneNumber, 'ZZ');
          return phoneNumber ? phoneNumber.isValid() : false;
        } catch (error) {
          return false;
        }
      }),
    otherwise: Yup.string().notRequired(), 
  }),
  DOB: Yup.date()
    .nullable()
    .required('Please, select the DOB.')
    .test('is-majority-age', 'You must be at least 18 years old', function (value) {
      if (!value) return true;

      const selectedDate = new Date(value);
      const currentDate = new Date();

      const age = currentDate.getFullYear() - selectedDate.getFullYear();

      return age >= 18;
    })
    .test('is-valid-year', 'Year must be within the last 90 years', (value) => {
      const today = new Date();
      const ninetyYearsAgo = new Date(today.getFullYear() - 90, today.getMonth(), today.getDate());
      return value && new Date(value) >= ninetyYearsAgo;
    }),
  password: Yup.string()
    .when('useOauth', (useOauth, field) => !useOauth ?  
    field.required('Password is required')
    .transform((originalValue, originalObject) => {
      const isEmpty = originalValue.trim() === '';

      if (isEmpty) {
        throw new Yup.ValidationError(
          'Password cannot be empty',
          originalValue,
          'password'
        );
      }

      const errors = passwordValidationRules
        .filter((rule) => !rule.rule(originalValue))
        .map((rule) => rule.message);

      if (errors.length > 0) {
        if (errors.length === 1) {
          throw new Yup.ValidationError(
            errors[0], 
            originalValue,
            'password'
          );
        } else {
          throw new Yup.ValidationError(
            errors.join(', ').replace(/,\s*$/, ''), 
            originalValue,
            'password'
          );
        }
      }
      return originalValue;
    })
    : field),
  confirmPassword: Yup.string()
    .when('useOauth', (useOauth, field) => !useOauth ?  
    field.required('Please confirm your password')
    .test('passwords-match', "Passwords don't match", function (value) {
      const { password } = this.parent;
      return value === password || !password;
    })
    : field),
  terms: Yup.boolean()
    .test('is-true', 'You must accept the terms and conditions', value => value === true)
    .required('You must accept the terms and conditions'),
});

const SignUp = () => {

  const { currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingSignup, setLoadingSignup] = useState(false);
  const [open, setOpen] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [openPrivacy, setOpenPrivacy] = useState(false);
  const [userData, setUserData] = useState();
  const handleOpen = () => setOpen(true);
  const handleOpenTerms = () => setOpenTerms(true);

  const handleClose = () => setOpen(false);
  const handleCloseTerms = (setFieldValue) => {
    setOpenTerms(false);
    setFieldValue("terms", true);
  }
  const handleOpenPrivacy = () => setOpenPrivacy(true);
  const handleOpenInfluencerProgram = () => {};  
  const handleClosePrivacy = (setFieldValue) => {
    setOpenPrivacy(false);
    setFieldValue("terms", true);
  }
  const { listingCatalogue } = useCatalogue();
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState([]);
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');


  const [status, setStatus] = useState('');
  const [userStatus, setUserStatus] = useState('');
  const [extensions, setExtensions] = useState([]);

  const [oauthData, setOauthData] = useState({});
  const [idToken, setIdToken] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const referral = urlParams.get('referral');
  const initialValues = {
      firstName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      accountType: '',
      accountTypeCompany: '',
      companyType: '',
      companyName: '',
      spotifyArtist: '',
      country: '',
      addressLine: '',
      phoneNumber: '',
      city: '',
      state: '',
      zipcode: '',
      DOB: '',
      migratoryState: '',
      password: '',
      terms: '',
      agree: false,
      useOauth: false,
      referral: referral
    }

  const getMinAgeDate = () => {
    const currentDate = new Date();
    const minAgeDate = new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate());
    return minAgeDate.toISOString().split('T')[0];
  };

  const getMaxAgeData = () => {
    const today = new Date();
    const ninetyYearsAgo = new Date(today.getFullYear() - 90, today.getMonth(), today.getDate());
    return ninetyYearsAgo.toISOString().split('T')[0];
  }

  const goToConfirm = (email, userId) => (
      navigate('/auth/confirm', { state: { email: userData.emailAddress, userId: userData.userId } })
    )

  useEffect(() => {
    if (location.state) {
      const {step, idToken, useOauth, useApple, ...rest} = location.state;
      if(idToken && useOauth) {
        const {given_name, family_name, email} = decodeJWT(idToken);
        setIdToken(idToken);
        if(useApple) {
          const {firstName, lastName} = rest;
          setOauthData({
            firstName: firstName,
            lastName: lastName,
            email: email,
            confirmEmail: email,
            useOauth: useOauth,
            useApple: useApple
          })
        }
        else {
          setOauthData({
            firstName: given_name,
            lastName: family_name,
            email: email,
            confirmEmail: email,
            useOauth: useOauth
          })
        }
        
      }
      if(step) {
        setActiveStep(step);
      }
    }

    const generateCountryOptions = () => {
      const countries = getCountries();
      const uniqueExtensions = new Set();
      const countriesCode = countries.map(c => {
        const code = getCountryCallingCode(c);
        uniqueExtensions.add(`+${code}`);

        return {
          id: c,
          value: c,
          label: c,
          countryCode: `+${code}`,
        }
      });

      // countries.forEach(country => {
      //   const code = getCountryCallingCode(country);
      //   uniqueExtensions.add(`+${code}`);

      // });
      setCountryCode(countriesCode);
      setExtensions(Array.from(uniqueExtensions).sort());
    };

    generateCountryOptions();
  }, []);

  useEffect(() => {
    if (listingCatalogue.country)
      setCountries(listingCatalogue.country);

    if (listingCatalogue.states)
      setStates(listingCatalogue.states);
  }, [listingCatalogue])

  const handleNext = () => {
    setActiveStep((old) => old + 1);
    const urlParams = new URLSearchParams(window.location.search);
    const referralValue = urlParams.get('referral');
    const newUrl = referralValue
      ? `/auth/register?step=2&referral=${encodeURIComponent(referralValue)}`
      : '/auth/register?step=2';
    window.history.pushState({ step: 2 }, '', newUrl);
    window.addEventListener('popstate', () => {
      setActiveStep(1);
    });
  };
  const filterStates = (country, setFieldValue) => {
    setFieldValue('country', country);
    const tmpCountry = countries.find(item => item.value === country);
    const code = countryCode.find(i => i.value === country);

    if (tmpCountry && code) {
      const tmpStates = states.filter(item => item.ParentID === tmpCountry.id);
      setFilteredStates(tmpStates);
      setFieldValue('countryCode', code.countryCode);
    } else {
      setFieldValue('countryCode', '');
    }
  }

  const onUserTypeChange = (setFieldValue) => {
    setFieldValue("spotifyArtist", "");
    setFieldValue("accountTypeCompany", "");
    setFieldValue("companyType", "");
    setFieldValue("companyName", "");
  }

  const onAccountTypeChange = (e, setFieldValue) => {
    setFieldValue("accountTypeCompany", e.target.value);
    setFieldValue("companyType", "");
    setFieldValue("companyName", "");
  }

  const handleSubmit = async (values, { setStatus }) => {
    setLoading(true);
    setErrorMessage('');
    if(oauthData.useApple) {
      values.password = "Abc@123!";
      values.confirmPassword = "Abc@123!";
      user_signupApple(idToken, values).then(response => {
        if(response.isSuccess) {
          navigate('/auth', {state: {verified: true}});
        }
      }).catch(error => {
        setStatus(error);
        scrollToTop('', 'top');
      }).finally(() => setLoading(false));
    }
    else if(oauthData.useOauth){
      values.password = "Abc@123!";
      values.confirmPassword = "Abc@123!";
      user_signupGoogle(idToken, values).then(response => {
        if(response.isSuccess) {
          navigate('/auth', {state: {verified: true}});
        }
      }).catch(error => {
        setStatus(error);
        scrollToTop('', 'top');
      }).finally(() => setLoading(false));
    }
    else {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const stepValue = urlParams.get('step');
        const valuesWithStep = {
          ...values,
          step: stepValue
        };
        const jsonValues = JSON.stringify(valuesWithStep, null, 2); 
        user_signup(values,jsonValues).then(response => {
          if (response) {
            if (response.isSuccess) {
              setUserData(response.user);
              handleOpen();
            } else {
              setStatus(response.message);
              scrollToTop('', 'top');
            }
          } else {
            setStatus('There was an error in the registration process');
            scrollToTop('', 'top');
          }
        }).catch(error => {
          setStatus(error);
          scrollToTop('', 'top');
        }).finally(() => setLoading(false));
      } catch (error) {
        console.error(error);
      }
    }
  }

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const scrollToTop = (message, element) => {
    if (element === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      setErrorMessage(message);
      scrollToElement(element);
    }
  };

  const sendAgain = () => {
    setStatus('');
    setUserStatus('');
    try {
       user_resendcode(userData.emailAddress).then(data => {
      if (data && data.isSuccess === true) {
        setUserStatus("Email sent.");
        setTimeout(() => {
          setUserStatus('');
        }, 5000);
      }
      else {
        setStatus(data.message);
      }
    });
    } catch (error) {
      console.error(error);
    }
  }

  const sendAgainSignup = (email) => {
    setStatus('');
    setUserStatus('');
    try {
      user_resendcode(email).then(data => {
      if (data && data.isSuccess === true) {
        setUserStatus("Email sent.");
        setTimeout(() => {
          setUserStatus('');
        }, 5000);
      }
      else {
        setStatus(data.message);
      }
    });
    } catch (error) {
      console.error(error);
    }
  }

  const confirmationEmail = (email,jsonValues) => {
    try {
      setLoadingSignup(true);
      user_emailExisting(email,jsonValues).then(data => {
      const jsonData = JSON.parse(data);
      if (jsonData.isSuccess) {
        if(jsonData?.emailVerified && (jsonData?.emailVerified.toLowerCase() === "false" || jsonData?.emailVerified === false)){
          setUserData(prevState => ({
            ...prevState,  
            emailAddress: email  
          }));
          sendAgainSignup(email);
          setOpen(true);
        }else{
          setErrorMessage("This email is already registered");
          scrollToTop('', 'top');
        }
      } else {
        setErrorMessage("");
        handleNext();
      }
    }).catch(error => {
      console.error('Error fetching user email existence:', error);
      setErrorMessage("Unexpected error");
      scrollToTop('', 'top');
    }).finally(setLoadingSignup(false));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if(errorMessage !== ""){
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    }
  }, [errorMessage]);

  return (
    <SignupContainer>
      <Heading previusPage={activeStep === 1 ? 'Sign Up' : 'Register'} />
      <div className='error-message-validation'>  {errorMessage && (<Alert alertType={ALERT_TYPE.error}>{errorMessage}</Alert>)}</div>
    
      <Formik
        enableReinitialize={true}
        initialValues={{ ...initialValues, ...oauthData }}
        validationSchema={loginSchema}
        onSubmit={handleSubmit}>

        {({ values, errors, touched, status, setFieldValue, handleBlur }) => (
          <>
            <CMDiv>
              {status &&
                <Alert alertType={ALERT_TYPE.error}>{status}</Alert>
              }
              {currentUser &&
                <Alert alertType={ALERT_TYPE.success}>{currentUser}</Alert>
              }
              <Form id='SignUp' autoComplete='false'>
                {activeStep === 1 ? (
                  <>
                    <div className='box-sizing'>
                      <Row className='w-100 mb-3'>
                        <Col sm={6} md={6}>
                          <div className='inputGroup'>
                            <label htmlFor='firstName'>First Name <span className="error-caption">*</span></label>
                            <InputField className="custom-form-control"
                              name='firstName' id='firstName'
                              placeholder='First Name'
                              isInvalid={errors.firstName && touched.firstName}
                              error={errors.firstName} maxLength={"20"}
                              onBlur={(e) => {
                                const trimmedValue = e.target.value.trim();
                                setFieldValue(e.target.name, trimmedValue);
                                handleBlur(e);
                              }} />
                          </div>
                        </Col>
                        {!oauthData.useOauth && 
                        <Col sm={6} md={6}>
                          <div className="inputGroup">
                            <label htmlFor='lastName'>Last Name <span className="error-caption">*</span></label>
                            <InputField className="custom-form-control" name='lastName' id='lastName' placeholder='Last Name' isInvalid={errors.lastName && touched.lastName} error={errors.lastName} maxLength={"20"} onBlur={(e) => {
                              const trimmedValue = e.target.value.trim();
                              setFieldValue(e.target.name, trimmedValue);
                              handleBlur(e);
                            }} />
                          </div>
                        </Col>
                        }
                        <Col sm={6} md={6}>
                          <div className="inputGroup">
                            <label htmlFor="email">Email <span className="error-caption">*</span></label>
                            <InputField className="custom-form-control" name='email' id='email' placeholder='Email' isInvalid={errors.email && touched.email} error={errors.email} onBlur={(e) => {
                              const trimmedValue = e.target.value.trim();
                              setFieldValue(e.target.name, trimmedValue);
                              handleBlur(e);
                            }} />
                          </div>
                        </Col>
                        <Col sm={6} md={6}>
                          <div className="inputGroup">
                            <label htmlFor="confirmEmail">Confirm Email <span className="error-caption">*</span></label>
                            <InputField className="custom-form-control" name='confirmEmail' id='confirmEmail' placeholder='Confirm Email Address' isInvalid={errors.confirmEmail && touched.confirmEmail} error={errors.confirmEmail} onBlur={(e) => {
                              const trimmedValue = e.target.value.trim();
                              setFieldValue(e.target.name, trimmedValue);
                              handleBlur(e);
                            }} />
                          </div>
                        </Col>
                      </Row>
                      <div className='checkbox-container'>
                        <label className={`marketing agreement ${values.agree ? 'checked' : ''}`}>
                          {/* <CheckIcon width={14} height={14} /> */}
                          <Field type="checkbox" name="agree" id="agree" />
                        </label>
                        <label htmlFor='agree'>
                          By clicking here, you agree to receive marketing emails from us
                        </label>
                      </div>
                    </div>
                    <BTNsmall>
                      <Button
                        type='button'
                        size="large"
                        className="btnSubmitSignUp"
                        isProgressButton={true}
                        progresscolor="#fff"
                        loading={loadingSignup}
                        disabled={
                          values.firstName.length > 50 ||
                          values.lastName.length > 50 ||
                          values.email.length === 0 ||
                          values.email.toLowerCase() !== values.confirmEmail.toLowerCase() ||
                          !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/i.test(values.email) ||
                          Object.keys(errors).some(key => ['firstName', 'lastName', 'email', 'confirmEmail'].includes(key))
                        }
                        onClick={() => {
                          const urlParams = new URLSearchParams(window.location.search);
                          const stepValue = urlParams.get('step');
                          const referralValue = urlParams.get('referral');
                          const valuesWithParams = {
                            ...values,
                            step: stepValue,
                            referral: referralValue,
                          };
                          const jsonValues = JSON.stringify(valuesWithParams, null, 2);
                          confirmationEmail(values.email, jsonValues);
                        }}
                                            >
                        Submit
                      </Button>
                    </BTNsmall>

                  </>
                )
                  : (
                    <>
                      <div className='form-container' id='accountTypeS'>
                        <div className="form-control fullwidth user-type">
                          <p>User type <span className="error-caption">*</span></p>
                          <div className='user-type-group' role="group" aria-labelledby="accountType">
                            <label className={`${values.accountType === 'Trader' ? 'checked' : ''}`}>
                              <Image src='trader-usertype.png' />
                              <Field type="radio" name="accountType" value="Trader" onClick={() => onUserTypeChange(setFieldValue)} />
                              Trader
                            </label>
                            <label className={`${values.accountType === 'Rightsholder' ? 'checked' : ''}`}>
                              <Image src='rightsholder-usertype.png' />
                              <Field type="radio" name="accountType" value="Rightsholder" onClick={() => onUserTypeChange(setFieldValue)} />
                              Rightsholder
                            </label>
                          </div>
                          <ErrorMessage name={'accountType'} error={errors.accountType} component={FormMessage} />
                        </div>
                        
                        {/* <div className='checkbox-container'>
                          <label className={`terms agreement ${values.enroll_influencer ? 'checked' : ''}`}>
                          <CheckIcon width={14} height={14} />
                          <Field type="checkbox" name="enroll_influencer" id="enroll_influencer" />                  
                          </label>              
                          <label>
                            Enroll me to the Influencer Program (Minimun of 100k followers required)
                          </label>                                                
                        </div>      */}
                      </div>
                      {values.accountType === 'Rightsholder' ? (
                        <>
                          <div className="form-container dotted-border">

                            <div className='form-control' id='spotifyArtistS'>
                              <Field
                                as='select'
                                name="idType"
                                style={{ height: "32px", marginBottom: "8px",border: "1px solid #E0E0E0", borderRadius:"5px" }}
                              >
                                <option selected disabled value='Select ID'>Select ID</option>
                                <option value="IPI/CAE Number">IPI/CAE Number</option>
                                <option value="ISRC">ISRC</option>
                                <option value="PRO Member ID">PRO Member ID</option>
                                <option value="Other">Other</option>
                              </Field>
                              <ErrorMessage name={'idType'} error={errors.idType} component={FormMessage} />
                              
                         

                              <label>IPI number</label>
                              <InputField className="field-max" name='spotifyArtist' id='spotifyArtist' placeholder='' isInvalid={errors.spotifyArtist && touched.spotifyArtist} error={errors.spotifyArtist} onBlur={(e) => {
                                const trimmedValue = e.target.value.trim();
                                setFieldValue(e.target.name, trimmedValue);
                                handleBlur(e);
                              }} />
                            </div>
                            <div className='form-control'></div>
                            <div className='form-control' id='accountTypeCompanyS'>
                              <label>Account type</label>
                              <Dropdown name={'accountTypeCompany'} id='accountTypeCompany' options={accountTypeCompanyOptions} onChange={(e) => onAccountTypeChange(e, setFieldValue)} />
                              <ErrorMessage name={'accountTypeCompany'} error={errors.accountTypeCompany} component={FormMessage} />
                            </div>
                            {values.accountTypeCompany === "Company" &&
                              <>
                                <div className='form-control' id='companyTypeS'>
                                  <label>Company type <span className="error-caption">*</span></label>
                                  <Dropdown name={'companyType'} id='companyType' options={CompanyOptions} isInvalid={errors.companyType && touched.companyType} error={errors.companyType} />
                                  <ErrorMessage name={'companyType'} error={errors.companyType} component={FormMessage} />
                                </div>

                                <div className='form-control' id='companyNameS'>
                                  <label>Company name</label>
                                  <InputField className="field-max" name='companyName' id='companyName' placeholder='' isInvalid={errors.companyName && touched.companyName} error={errors.companyName} />
                                </div>
                              </>
                            }
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="form-container dotted-border">

                            <div className='form-control' id='accountTypeCompanyS'>
                              <label>Account type</label>
                              <Dropdown name={'accountTypeCompany'} id='accountTypeCompany' options={accountTypeCompanyOptions} onChange={(e) => onAccountTypeChange(e, setFieldValue)} />
                              <ErrorMessage name={'accountTypeCompany'} error={errors.accountTypeCompany} component={FormMessage} />
                            </div>

                            {values.accountTypeCompany === "Company" &&
                              <>
                                <div className='form-control' id='companyTypeS'>
                                  <label>Company type</label>
                                  <Dropdown name={'companyType'} id='companyType' options={CompanyOptions} />
                                  <ErrorMessage name={'companyType'} error={errors.companyType} component={FormMessage} />
                                </div>

                                <div className='form-control fullwidth' id='companyNameS'>
                                  <label>Company name</label>
                                  <InputField name='companyName' id='companyName' placeholder='' isInvalid={errors.companyName && touched.companyName} error={errors.companyName} />
                                </div>
                              </>
                            }

                          </div>
                        </>
                      )
                      }

                      <div className="form-container dotted-border">
                        <div className='form-control' id='countryS'>
                          <label >Country <span className="error-caption">*</span></label>
                          <Dropdown
                            name='country'
                            id='country'
                            options={countries}
                            value={values.country}
                            onChange={async e => filterStates(e.target.value, setFieldValue)}
                          />
                          <ErrorMessage name={'country'} error={errors.country} component={FormMessage} />
                        </div>

                        <div className="form-control"></div>

                        <div className='form-control' id='addressLineS'>
                          <label>Address line 1</label>
                          <InputField className="field-max" name='addressLine' id='addressLine' placeholder='' isInvalid={errors.addressLine && touched.addressLine} error={errors.addressLine} onBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setFieldValue(e.target.name, trimmedValue);
                            handleBlur(e);
                          }} />
                        </div>

                        <div className='form-control' id='phoneNumberS'>
                          <label>Phone number</label>
                          <div style={{ display: "flex" }} className="field-max">
                            <Field
                              as='select'
                              name='countryCode'
                              id='extension'
                              value={values.countryCode}
                              style={{ height: "29px", marginTop: "8px", maxWidth: "60px" }}>
                              <option selected disabled value=''></option>
                              {extensions.map(extension => (
                                <option
                                  key={extension}
                                  value={extension}>
                                  {extension}
                                </option>
                              ))}
                            </Field>
                            <InputField name='phoneNumber' id='phoneNumber' placeholder='1234567890' isInvalid={errors.phoneNumber && touched.phoneNumber} error={errors.phoneNumber} onBlur={(e) => {
                              const trimmedValue = e.target.value.trim();
                              setFieldValue(e.target.name, trimmedValue);
                              handleBlur(e);
                            }} />
                          </div>
                        </div>



                        <div className='form-control' id='cityS'>
                          <label>City</label>
                          <InputField className="field-max" name='city' id='city' placeholder='' isInvalid={errors.city && touched.city} error={errors.city} onBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setFieldValue(e.target.name, trimmedValue);
                            handleBlur(e);
                          }} />
                        </div>

                        {filteredStates.length > 0 && (
                          <div className='form-control'>
                            <label>State </label>
                            <Dropdown name={'state'} options={filteredStates} />
                          </div>
                        )}

                        <div className='form-control' id='zipcodeS'>
                          <label>Zip code</label>
                          <InputField className="field-max" type="text" name='zipcode' id='zipcode' placeholder='' isInvalid={errors.zipcode && touched.zipcode} error={errors.zipcode} onBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setFieldValue(e.target.name, trimmedValue);
                            handleBlur(e);
                          }} />
                        </div>

                        <div className='form-control' id='DOBS'>
                          <label>DOB <span className="error-caption">*</span></label>
                          {window.safari !== undefined && (
                            <Field name="DOB" className="field-max">
                              {({ field, form }) => (
                                <>
                                  <Datepicker2 form={form} field={field} />
                                  <DatepickerErrorMessage name="DOB" />
                                </>
                              )}
                            </Field>
                          )}
                          {window.safari === undefined && (
                            <InputField
                              type='date'
                              min={getMaxAgeData()}
                              name='DOB'
                              id='DOB'
                              placeholder=''
                              isInvalid={errors.DOB && touched.DOB}
                              error={errors.DOB}
                              max={getMinAgeDate()}
                              className="field-max" />
                          )}
                        </div>
                      </div>

                      <div className='form-container ' id='migratoryStateS'>
                        <div className="form-control fullwidth migratory-status" >
                          <div role="group" aria-labelledby="migratoryState" className="migratoryState">
                            <label>
                              <Field type="radio" name="migratoryState" value="U.S. Citizen" />
                              U.S. Citizen
                            </label>
                            <label>
                              <Field type="radio" name="migratoryState" value="U.S. Resident" />
                              U.S. Resident
                            </label>
                            <label>
                              <Field type="radio" name="migratoryState" value="Non U.S. Resident" />
                              Non U.S. Resident
                            </label>
                          </div>
                          <ErrorMessage name={'migratoryState'} error={errors.migratoryState} component={FormMessage} />
                        </div>
                        {!oauthData.useOauth && 
                        <>
                        <div className='form-control' id='passwordS'>
                          <label>Password <span className="error-caption">*</span></label>
                          <InputField
                            type="password"
                            name="password"
                            id="password"
                            placeholder=''
                            isInvalid={!!errors.password && (touched.password || values.password.length > 0)}
                            error={errors.password}
                            autoComplete="new-password"
                            className="field-max"
                          />
                        </div>
                        <div className='form-control' id='confirmPasswordS'>
                          <label>Confirm Password <span className="error-caption">*</span></label>
                          <InputField  className="field-max" type="password" name='confirmPassword' id='confirmPassword' placeholder='' isInvalid={errors.confirmPassword && touched.confirmPassword} error={errors.confirmPassword} autoComplete="new-password" />
                        </div>
                        </>
                        } 

                         <div className='form-control' id='referralS'>
                          <label>Referral</label>
                          <InputField className="field-max" name='referral' id='referral'  placeholder='' isInvalid={errors.referral && touched.referral} error={errors.referral} onBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setFieldValue(e.target.name, trimmedValue);
                            handleBlur(e);
                          }} />
                        </div> 

                        <div className='checkbox-container' id="termsS">
                          <label className={`terms agreement ${values.terms ? 'checked' : ''}`}>
                            <CheckIcon width={14} height={14} />
                            <Field type="checkbox" name="terms" id="terms" />
                          </label>
                          <label htmlFor='terms'>
                            I agree to accept the <a onClick={handleOpenTerms}>Terms & conditions</a> & <a onClick={handleOpenPrivacy}>Privacy Policy.</a>
                          </label>
                        </div>
                        <ErrorMessage name={'terms'} error={errors.terms} component={FormMessage} /></div>

                      <Button
                        type='submit'
                        size="large"
                        isProgressButton={true}
                        progresscolor="#fff"
                        disabled={loading}
                        loading={loading}
                        onClick={() => {
                          const errorKeys = Object.keys(errors);
                          if (errorKeys.length > 0) {
                            const firstErrorKey = errorKeys[0];
                            scrollToTop('Fill all required fields correctly', firstErrorKey + 'S');
                          }
                        }}
                      >Register
                      </Button>
                    </>
                  )
                }

                <WelcomeModal open={open} onClose={handleClose}>
                  <CMCloseButton onClick={goToConfirm}>
                    <CloseIcon width={16} height={16} />
                  </CMCloseButton>
                  <div className='title'>
                    <Image src={'logo.png'} alt={'Music Bull'} width={150} />
                    <h2>Welcome to Musicbull!</h2>
                  </div>
                  {status && <Alert alertType={ALERT_TYPE.error}>{status}</Alert>}
                  {userStatus && <Alert alertType={ALERT_TYPE.success} style={{ paddingLeft: '10px' }}>{userStatus}</Alert>}
                  <div>
                    <p>Please, check your email: {values.email}<br />and activate your account by following the steps explained in the email.
                    
                    If you don't see our email in your inbox, please check your spam folder</p>
                  </div>
                  <div className="button-container">
                    <Button color="blue" onClick={sendAgain}>Send again</Button>
                    <Button buttonType={BUTTON_TYPE_CLASSES.OutlinedButton} color="blue" onClick={goToConfirm}>Received</Button> 

                  </div>
                </WelcomeModal>


                <TermsModal open={openTerms} onClose={() => handleCloseTerms(setFieldValue)}/>

                <WelcomeModal open={openPrivacy} onClose={() => handleClosePrivacy(setFieldValue)}>
                  <div className='title'>
                    <h2>Privacy Policy</h2>
                  </div>
                  <div style={{ maxHeight: "250px", overflow: "auto" }}>
                    <PrivacyContent />
                  </div>
                  <div className="button-container">
                    <Button color="blue" onClick={() => handleClosePrivacy(setFieldValue)}>Accept</Button>
                  </div>
                </WelcomeModal>
              </Form>
            </CMDiv>
          </>
        )}
      </Formik>
    </SignupContainer>
  );
}



export default SignUp;